import { Component, ChangeDetectionStrategy, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { IPlannedHandoffException } from 'src/app/common/models/plannedHandoffException';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-confirm-planned-handoff-exception-delete',
  templateUrl: './confirm-planned-handoff-exception-delete.component.html',
  styleUrls: ['./confirm-planned-handoff-exception-delete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CdkScrollable, MatDialogContent, MatButton, DatePipe],
})
export class ConfirmPlannedHandoffDeleteComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmPlannedHandoffDeleteComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public plannedHandoffException: IPlannedHandoffException,
  ) {}

  public confirm(decision: boolean): void {
    this.dialogRef.close(decision);
  }
}
